/* libs/iot-platform/iot-platform-ui-favorite-view/src/lib/components/favorite-view-forms/report-form/report-form.component.scss */
.status-toggle--active {
  --mat-slide-toggle-selected-track-color: var(--al-color-palette-green400);
  --mat-slide-toggle-selected-hover-track-color: var(--al-color-palette-green400);
  --mat-slide-toggle-selected-focus-track-color: var(--al-color-palette-green400);
  --mat-slide-toggle-selected-pressed-track-color: var(--al-color-palette-green400);
  --mat-slide-toggle-selected-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-selected-hover-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-selected-focus-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-selected-pressed-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-unselected-track-color: var(--al-color-palette-green400);
  --mat-slide-toggle-unselected-hover-track-color: var(--al-color-palette-green400);
  --mat-slide-toggle-unselected-focus-track-color: var(--al-color-palette-green400);
  --mat-slide-toggle-unselected-pressed-track-color: var(--al-color-palette-green400);
  --mat-slide-toggle-unselected-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-unselected-hover-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-unselected-focus-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-unselected-pressed-handle-color: var(--al-color-text-white);
}
.status-toggle--inactive {
  --mat-slide-toggle-selected-track-color: var(--al-color-palette-red600);
  --mat-slide-toggle-selected-hover-track-color: var(--al-color-palette-red600);
  --mat-slide-toggle-selected-focus-track-color: var(--al-color-palette-red600);
  --mat-slide-toggle-selected-pressed-track-color: var(--al-color-palette-red600);
  --mat-slide-toggle-selected-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-selected-hover-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-selected-focus-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-selected-pressed-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-unselected-track-color: var(--al-color-palette-red600);
  --mat-slide-toggle-unselected-hover-track-color: var(--al-color-palette-red600);
  --mat-slide-toggle-unselected-focus-track-color: var(--al-color-palette-red600);
  --mat-slide-toggle-unselected-pressed-track-color: var(--al-color-palette-red600);
  --mat-slide-toggle-unselected-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-unselected-hover-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-unselected-focus-handle-color: var(--al-color-text-white);
  --mat-slide-toggle-unselected-pressed-handle-color: var(--al-color-text-white);
}
/*# sourceMappingURL=report-form.component.css.map */
